
import { Component, Vue, Watch } from 'vue-property-decorator'
import { User } from '../../lib/models/User'
import { Team } from '@/lib/models/Team'
import { RallyRound } from '../../lib/models/RallyRound'
import { Http } from '@/lib/utils/Http'

@Component({})
export default class DriveUploader extends Vue {
  get rallyRound () {
    return this.$store.state.PageURLRallyRound.rallyRound
  }

  team: Team = new Team()

  mounted () {
    if (this.rallyRound.driveUploaderLink) {
      this.loadDriveUploader()
    }

    this.setupDriveUploaderText()
    // this.setupCallback()
    this.loadLoggedInTeam()
  }

  async loadLoggedInTeam () {
    const res = await Http.request(`/api/rally-round/${this.$route.params.rallyRoundId}/team/logged-in`)
    this.team = await res.json()
  }

  setupDriveUploaderText () {
    // DEACTIVATED cause of Monday item: 9264799595
    /* setInterval(() => {
      const heading = document.querySelector('.uploader__heading')
      if (heading) {
        heading.innerHTML = ''
      }

      const mid = document.querySelector('.uploader__divider')
      if (mid) {
        mid.innerHTML = ''
      }

      const button = document.querySelector('.uploader__button')
      if (button) {
        button.innerHTML = 'Wähle die Dateien'
      }

      const dontTurnOffBrowserNote = document.querySelector('.uploader__info-strong')
      if (dontTurnOffBrowserNote) {
        dontTurnOffBrowserNote.innerHTML = 'Bleib auf dieser Seite bis der Upload abgeschlossen ist'
      }

      const againButton = document.querySelector('.uploader__done-footer-embed')
      if (againButton) {
        againButton.remove()
      }
    }, 10) */
  }

  setupCallback () {
    (window as any).driveUploaderCallback = (status: any, result: any, instance: any) => {
      if (status === 'init') {
        instance.setHook('beforeupload', this.onBeforeUpload)
      }
    }
  }

  onBeforeUpload (done: any, files: any) {
    const renamedFiles = []
    const loggedInUser = this.$store.state.LoggedInUser.user as User
    const rallyRoundId = this.$store.state.PageURLRallyRound.rallyRound.id
    for (const currentFile of files) {
      renamedFiles.push(new File([currentFile], `#${this.team.number}-${loggedInUser.firstname} ${loggedInUser.lastname}-${rallyRoundId}`, { type: currentFile.type }))
    }
    // files.length = 0
    console.log(files)

    // files.length = 0
    // eslint-disable-next-line
    files.push(...renamedFiles)

    // eslint-disable-next-line
    // files = renamedFiles
    done()
  }

  @Watch('rallyRound')
  onRallyRoundChange () {
    this.loadDriveUploader()
  }

  loadDriveUploader () {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', this.rallyRound.driveUploaderLink)
    document.head.appendChild(recaptchaScript)
  }
}
